const prioritizedServiceTypes = [
  'Šeimos gydytojų konsultacijos',
  'Gydytojų specialistų konsultacijos',
  'Vaikų gydytojų specialistų konsultacijos',
  'Šeimos gydytojų konsultacijos namuose',
  'Nuotolinės gydytojų konsultacijos',
  'Nuotolinės vaikų gydytojų konsultacijos',
];

const serviceTypePriority = new Map(
  prioritizedServiceTypes.map((title, index) => [title, index]),
);

const lithuanianCollator = new Intl.Collator('lt', {
  sensitivity: 'base',
});

const compareServiceTypes = (left, right) => {
  const leftPriority = serviceTypePriority.get(left);
  const rightPriority = serviceTypePriority.get(right);

  if (leftPriority !== undefined || rightPriority !== undefined) {
    if (leftPriority === undefined) return 1;
    if (rightPriority === undefined) return -1;
    return leftPriority - rightPriority;
  }

  return lithuanianCollator.compare(left, right);
};

const compareServices = (left, right) => {
  const titleComparison = lithuanianCollator.compare(
    left?.serviceTitle ?? '',
    right?.serviceTitle ?? '',
  );

  if (titleComparison !== 0) return titleComparison;

  const specialistComparison = lithuanianCollator.compare(
    left?.specialistName ?? '',
    right?.specialistName ?? '',
  );

  if (specialistComparison !== 0) return specialistComparison;

  return lithuanianCollator.compare(
    left?.departmentName ?? '',
    right?.departmentName ?? '',
  );
};

export const groupAndOrderSearchResults = (services = []) => {
  const groupedServices = services.reduce((groups, service) => {
    const serviceTypeTitle = service?.serviceTypeTitle ?? '';

    if (!groups[serviceTypeTitle]) {
      groups[serviceTypeTitle] = [];
    }

    groups[serviceTypeTitle].push(service);
    return groups;
  }, {});

  return Object.fromEntries(
    Object.entries(groupedServices)
      .sort(([leftTitle], [rightTitle]) =>
        compareServiceTypes(leftTitle, rightTitle),
      )
      .map(([serviceTypeTitle, groupedResults]) => [
        serviceTypeTitle,
        groupedResults.sort(compareServices),
      ]),
  );
};

